import { AbstractSet } from './AbstractSet';
import { SetListenerIfc } from '../SetListenerIfc';
import { BitBoardEntity } from '../../utils/BitBoardEntity';
import { RecShapeIfc } from '../../shape/RecShapeIfc';
import { WriteRecord } from '../../utils/WriteRecord';
//import { RecordUpdater } from '../../utils/RecordUpdater';

export class RecordUpdater extends WriteRecord{
    cSet:ConcreteSet;
    entity:BitBoardEntity;
    
    constructor(cSet:ConcreteSet, shape:RecShapeIfc, id:number)
    {
        super(shape, id);
        this.cSet = cSet;
        this.entity = new BitBoardEntity(0, 0);
    }
    
    public flush():void
    {
        this.cSet.cellsUpdated(this.entity, this.getId());
    }
    
    public setIntAt(position:number, value:number):void
    {
        this.entity.setPosition(position);
        this.getRecShape().setIntAt(this.getId(), position, value);
    }
    
    public setNumberAt(position:number, value:number):void
    {
        this.entity.setPosition(position);
        this.getRecShape().setNumberAt(this.getId(), position, value);
    }
    
    public setBooleanAt(position:number, value:boolean):void
    {
        this.entity.setPosition(position);
        this.getRecShape().setBooleanAt(this.getId(), position, value);
    }
    
    public setStringAt(position:number, value:string):void
    {
        this.entity.setPosition(position);
        this.getRecShape().setStringAt(this.getId(), position, value);
    }
}

export class ConcreteSet extends AbstractSet implements SetListenerIfc{
        
    
    constructor(shape:RecShapeIfc)
    {
        super(shape);
    }
    
    isSetListener():boolean{
        return true;
    }

    public getRecordUpdater(id:number):RecordUpdater
    {
        return new RecordUpdater(this, this.getShape(), id);
    }
    
    public destructImpl():void
    {
    
    }
    
    public begin():void
    {
        this.dispatcher.begin();
    }
    
    public end():void
    {
        this.dispatcher.end();
    }
    
    public reset():void
    {
        super.reset();
        this.dispatcher.reset();
    }
    
    public cellsUpdated(colls:BitBoardEntity, id:number):void
    {
        this.dispatcher.cellsUpdated(colls, id);
    
    }
    
    public deleteRecord(id:number):void
    {
        this.removeRecord(id);
        this.dispatcher.deleteRecord(id);
    }
    
    public deleteRecords(ids:Array<number>):void
    {
        for (let i:number = 0; i < ids.length; i++)
        {
            this.removeRecord(i);
        }
        this.dispatcher.deleteRecords(ids);
    }
    
    public addRecords(records:Array<number>):void
    {
        var newRecords:Array<number> = new Array<number>();
        for (let recordId of records)
        {
            this.put(recordId);
            newRecords.push(recordId);
        }
        this.dispatcher.addRecords(records);
    }
    
    public addRecord(recordId:number):void
    {
        this.put(recordId);
        this.dispatcher.addRecord(recordId);
    }
    
    public setContainerMetaData(name:string, value:string):void
    {
        this.addMeta(name, value);
        this.dispatcher.setContainerMetaData(name, value);
    
    }
    
    public setContainerMetaDatas(names:Array<string>, values:Array<string>):void
    {
        this.addMetas(names, values);
        this.dispatcher.setContainerMetaDatas(names, values);
    }
    
    public removeContainerMetaDatas(names:Array<string>):void
    {
        this.removeMetas(names);
        this.dispatcher.removeContainerMetaDatas(names);
    }
    
    public removeMetaData(name:string):void
    {
        this.removeMeta(name);
        this.dispatcher.removeMetaData(name);
    }
}